module.exports = __webpack_public_path__ + "assets/images/red-alert.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/red-alert.png
// module id = 1525
// module chunks = 1